
<ngx-datatable 
    #table 
    class='material' 
    [loadingIndicator]="loadingIndicator"
    [columns]="columns" 
    [columnMode]="'force'" 
    [headerHeight]="50"                       
    [footerHeight]="50" 
    [rowHeight]="'auto'" 
    [rows]='rows'>

    <ngx-datatable-column name="Tipo" prop="tipo" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-tipo="value" ngx-datatable-cell-template>
            {{tipo.nome}}
        </ng-template>
    </ngx-datatable-column>                

    <ngx-datatable-column name="Nome" prop="nome" [sortable]="false" [width]="400">
        <ng-template let-rowIndex="rowIndex" let-nome="value" ngx-datatable-cell-template>
            {{nome}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Emissor" prop="nome" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            {{ getEmissor(row) }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Data Vencimento" prop="data_vencimento" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-data_vencimento="value" ngx-datatable-cell-template>
            {{data_vencimento | date:'dd/MM/yyyy'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
            
            <button mat-icon-button matTooltip="Alterar Produto" (click)="openAlterar(id)">
                <mat-icon aria-label="Editar Produto">edit</mat-icon>
            </button>

            <button *ngIf="params.inative == false" mat-icon-button color="warn" matTooltip="Inativar Produto" (click)="ativeAndInative(id)">
                <mat-icon aria-label="Inativar Produto">close</mat-icon>
            </button>

            <button *ngIf="params.inative == true" mat-icon-button matTooltip="Ativar Produto" (click)="ativeAndInative(id)">
                <mat-icon aria-label="Ativar Produto">add</mat-icon>
            </button>

            <button mat-icon-button color="warn" matTooltip="Excluir Produto" (click)="delete(id)">
                <mat-icon aria-label="Excluir Produto">delete</mat-icon>
            </button>
        </ng-template>
    </ngx-datatable-column>

</ngx-datatable>

<div style="padding: 5px 10px">
    <mat-paginator 
        #paginator 
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent($event)">
    </mat-paginator>
</div>